const sortDatesIncludingPresent = function (a, b) {
  if (a === b) {
    return 0;
  } else if (a === null) {
    return -1;
  } else if (b === null) {
    return 1;
  } else {
    return new Date(b) - new Date(a);
  }
};
export default sortDatesIncludingPresent;
